import { useQuery } from '@tanstack/react-query';

import { StatusCode } from '@hungryroot/rest';
import {
  getTagGroup,
  type GetTagGroupParams,
  type GetTagGroupResponse as TagGroupResponse,
} from '@hungryroot/rest/api/get_tag_group/get';

function key(tagGroupId: number, expandDislikes?: boolean) {
  return ['tag group', tagGroupId, expandDislikes];
}

const TIME_LIMIT = 5 * 60 * 1000;

/**
 * @deprecated Consider using `useTagGroup()` instead.
 */
export function useApiV1TagGroup(
  { tagGroupId, expandDislikes }: GetTagGroupParams,
  options: { enabled?: boolean } = {}
) {
  const tagGroupKey = key(tagGroupId, expandDislikes);
  return useQuery({
    queryKey: tagGroupKey,
    queryFn: async () => {
      const resp = await getTagGroup({ tagGroupId, expandDislikes });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: TIME_LIMIT,
    staleTime: TIME_LIMIT,
  });
}

function shuffleArray<T>(a: T[]): T[] {
  let j, x, i: number;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
}

export function useApiV1TagGroupShuffled(
  { tagGroupId, expandDislikes }: GetTagGroupParams,
  options: { enabled?: boolean } = {}
) {
  const tagGroupKey = key(tagGroupId);
  return useQuery({
    queryKey: tagGroupKey,
    queryFn: async () => {
      const resp = await getTagGroup({ tagGroupId, expandDislikes });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }
      const data = { ...resp.data, tags: [shuffleArray(resp.data.tags[0])] };

      return data as TagGroupResponse;
    },
    ...options,
  });
}
